/*!
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 * Version 5.4.0.0
 */

const PositionDroiteCercle = require('../types/PositionDroiteCercle')
const PositionDroites = require('../types/PositionDroites')
const PositionCercleCercle = require('../types/PositionCercleCercle')
const Vect = require('../types/Vect')

// import Point from '../types/Point'

// mtg32.kernel remplacé par mtg32.k pour gagner de la place.
const kernel = {
  svgns : "http://www.w3.org/2000/svg",
  ConvDegRad : Math.PI/180,
  ConvRadDeg : 180/Math.PI,
  uniteAngle : {radian : 0, degre : 1},
  _digit64 : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+#",
  _digit64_standard : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  erreurCalculException : "Erreur de calcul",
  NombreMaxiTermesSuiteRec : 100000,
  MIN_VALUE : -2147483648,
  Max_VALUE : 2147483647,
  // Ajout version 5.0.3 pour modification de testToile
  SHORT_MIN_VALUE : -32768,
  SHORT_MAX_VALUE : +32767
};
kernel.cos30 = Math.cos(30*kernel.ConvDegRad)
kernel.sin30 = 0.5
// Ajout version mtgApp pour gérer les écarns tactiles ou non //
kernel.distMinForTouch = 20;
kernel.distMinForMouse = 10;

//
/**
 * Fonction de récupération des paramètres GET de la page
 * @return Array Tableau associatif contenant les paramètres GET
 */
/*
mtg32.extractUrlLang = function(){
	var t = location.search.substring(1).split('&');
	for (var i=0; i<t.length; i++){
		var x = t[i].split('=');
		if (x[0] === "lang") return x[1];
	}
	return ""; // Français par défaut
};
*/

/**
 * Fonction créant un élément de nom name dans le namespace http://www.w3.org/2000/svg
 * avec les attributs de l'objet att passés en paramètre
 * @param name
 * @param att
 * @returns {Element}
 */
kernel.cens = function(name, att) {
  var element = document.createElementNS(kernel.svgns, name);
  if (att) {
    for (var o in att) {
      if (att.hasOwnProperty(o)) element.setAttribute(o, att[o]);
    }
  }
  return element;
};

/**
 * Fonction créant un élément de nom name
 * avec les attributs de l'objet att passés en paramètre
 * @param name
 * @param att
 * @returns {Element}
 */

kernel.ce = function(name,att) {
  var element = document.createElement(name);
  if (arguments.length > 0) {
    for (var o in att) {
      if (att.hasOwnProperty(o)) element.setAttribute(o, att[o]);
    }
  }
  return element;
};

kernel.userLan = function() {
  /*
  if (mtg32.extractUrlLang() === "") {
    var ch = navigator.languages && navigator.languages[0] ||
    navigator.language ||
    navigator.userLanguage;
    return ch.substring(0,2);
  }
  else return "fr";
  */
  var ch = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
  if (ch) return ch.substring(0,2);
  else return "fr";

};

/*
kernel.initTextes = function(bTextesComplets) {
  const s = kernel.userLan()
  if (s === "fr") kernel.textes = require('../textes/textes_fr')
  else if(s === "es") kernel.textes = require('../textes/textes_es')
  else kernel.textes = require('../textes/textes_en')
  // remplacer needTextesComplets par le test pour savoir s'il faut ajouter le reste
  if (bTextesComplets) {
    let textesExt = {}
    if (s === "fr") textesExt = require('../textes/textes_frAdd')
    else if(s === "es") textesExt = require('../textes/textes_esAdd')
    else textesExt = require('../textes/textes_enAdd')
    // et on ajoute ça à textes
    Object.assign(kernel.textes, textesExt)
  }
}
*/

/*
kernel.initTextes = function(bTextesComplets, callBack) {
  kernel.textes = {};
  const s = kernel.userLan();
  if (s === "fr") require.ensure(['../textes/textes_fr'], function () {
    Object.assign(kernel.textes, require('../textes/textes_fr'));
    if (bTextesComplets) require.ensure(['../textes/textes_frAdd'], function () {
      Object.assign(kernel.textes, require('../textes/textes_frAdd'));
      callBack();
    });
    else callBack();
  })
  else
  if (s === "en") require.ensure(['../textes/textes_en'], function () {
    Object.assign(kernel.textes, require('../textes/textes_en'));
    if (bTextesComplets) require.ensure(['../textes/textes_enAdd'], function () {
      Object.assign(kernel.textes, require('../textes/textes_enAdd'));
      callBack();
    });
    else callBack();
  })
  else {
    Object.assign(kernel.textes, require('../textes/textes_es'));
    if (bTextesComplets) require.ensure(['../textes/textes_esAdd'], function () {
      Object.assign(kernel.textes, require('../textes/textes_esAdd'));
      callBack();
    });
    else callBack();
  }
}
*/

/**
 * Renvoie la chaine de code ch suivant a langue utilisée par la navigateur.
 * textes est une variable globale initialisée au début de l'apli
 * @param {type} ch
 * @returns {mtg32.textes_en|mtg32.textes_fr|mtg32.textes_es}
 *
 */
kernel.getString = function(ch) {
  return kernel.textes[ch] || "";
};

/**
 * Fonction renvoyant true si la valeur absolue de x est inférieure à 10^-9
 * @param {Float} x
 * @returns {Boolean}
 */
kernel.zero = function(x) {
  return (Math.abs(x)<1e-9);
};
/**
 * Fonction renvoyant true si la valeur absolue de x est inférieure à 10^-13
 * @param {Float} x
 * @returns {Boolean}
 */

kernel.zero13 = function(x) {
  return (Math.abs(x)<1e-13);
};
/**
 * Renvoie une chaîne de caractères reprséentant le nombre number avec
 * digits décimales.
 * @param {Float} number
 * @param {Integer} digits
 * @returns {String}
 */
// Modifié version 5.1 pour tenir compte d'une écriture scientifique
kernel.chaineNombre =  function(number, digits) {
  var ind,indexp,exp,nb;
  if (number === 0) return "0";
  if (number === Number.NEGATIVE_INFINITY) return "-∞";
  if (number === Number.POSITIVE_INFINITY) return "∞";
  var ch = number.toFixed(digits);
  indexp = ch.indexOf("e");
  if (indexp === -1) exp = "";
  else {
    exp = ch.substring(indexp);
    ch = ch.substring(0, indexp);
    nb = parseFloat(ch);
    ch = nb.toFixed(digits);
  }
  var i = ch.length-1;
  if ((ind = ch.indexOf('.', 0)) !== -1) {
    while ((i>=ind) && (ch.charAt(i) === "0" || ch.charAt(i) === ".")) i--;
    ch = ch.substring(0, i+1);
  }
  if (ch==="-0") return "0" + exp;
  // else return ch; // Modification version 4.9.2. On rajoute un espace si le nombre est négatif après le signe -
  if (ch.charAt(0) === "-") return "- " + ch.substring(1) + exp;
  else return ch + exp;
};
/**
 * Fonction renvoyant une chaîne de caractères codant en base 64 le tableau de bytes ba.
 * Si la dimension du tableau n'est pas un multiple de 3, un ou deux zéros lui sont ajoutés et la chaîne
 * de caractères se termine par un ou deux caractères =
 * @param {type} ba : Un tableau de caractères qui représentent des bytes
 * @param {type} bstandard : Si true on encode de façon standard sinon avec encodage mathGraph32 avec / remplacé par  #
 * @returns {String}
 */
kernel.base64Encode = function(ba, bstandard) {
  // Il faut que la dimension du tableau de bytes soit un multiple de 3 (3 bytes seront codés sur 4 caractères)
  // A noter que un ou deux bytes mis à zéro de plus seront peut-être codés. Pour chacun on mettra un signe = à la fin
  // de la chaîne de caractères
  var digit = bstandard ? kernel._digit64_standard : kernel._digit64;
  var len = ba.length;
  var r = len % 3;
  var q = Math.floor((len-1) / 3);
  var q2 = q+1;
  if (r !== 0) {
      var ba2 = new Array(q2*3);
      for (var j = q*3 + r; j < q2*3; j++) ba2[j] = 0;
      for (var k = 0; k < len;  k++) ba2[k] = ba[k];
      ba = ba2;
  }
  var ch = "";
  for (var i = 0; i < q2*3; i+=3) {
    var n = ((ba[i] & 0xff) << 16) + ((ba[i+1] & 0xff) << 8) + (ba[i+2] & 0xff); // Les poids forts en premier
    ch += digit.charAt((n >> 18) & 0x3f);
    ch += digit.charAt((n >> 12) & 0x3f);
    ch += digit.charAt((n >> 6) & 0x3f);
    ch += digit.charAt(n & 0x3f);
  }
  // Revu version mtgApp
  // var paddingCount = Math.floor((3 - r) % 3); // nul si r = 0 // 1 si r = 2 et 2 si r = 3 c'est le nombre de = à mettre à la fin
  var paddingCount = (3 - r) % 3; // nul si r = 0 // 1 si r = 2 et 2 si r = 3 c'est le nombre de = à mettre à la fin
  return ch.substring(0, (q+1)*4 - paddingCount) + "==".substring(0, paddingCount);
};
/**
 * Fonction renvoyant un tableau d'entiers représentant des bytes d'un flux de bytes.
 * @param {String} xmlString : une chaîne base64.
 * @param {type} bstandard : Si true on décode de façon standard sinon avec encodage mathGraph32 avec / remplacé par  #
 * @returns {Array} : Tableau de bytes.
 */
kernel.base64Decode = function(xmlString, bstandard) {
  var digit = arguments.length === 1 ? kernel._digit64 : (bstandard ? kernel._digit64_standard : kernel._digit64);
  var paddingCount = 0;
  var len = xmlString.length;
  var indegal = xmlString.indexOf('=');
  if (indegal !== -1 ) {
      if (xmlString.charAt(len - 1) === '=') {
          if (xmlString.charAt(len - 2) === '=') paddingCount = 2;
          else paddingCount = 1;
      }
      xmlString = xmlString.substring(0, indegal) + "AA".substring(2-paddingCount); // On remplace les = par des An donc des zéros
  }
  else paddingCount = 0;
  // Ligne suivante modifiée JavaScript
  var barray = new Array((Math.floor((xmlString.length-1)/4)+1)*3 - paddingCount);
  var der = len - paddingCount;
  var j = 0;
  for (var i = 0; i < len; i += 4) {
      var car1 = xmlString.charAt(i);
      var car2 = xmlString.charAt(i+1);
      var car3 = xmlString.charAt(i+2);
      var car4 = xmlString.charAt(i+3);
      var n = (digit.indexOf(car1) << 18) + (digit.indexOf(car2) << 12) +
        (digit.indexOf(car3) << 6) + digit.indexOf(car4);
      if (i + 3 < der) barray[j + 2] = (n & 0xff);
      if (i + 2 < der) barray[j + 1] = ((n >> 8) & 0xff);
      barray[j] = ((n >> 16) & 0xff);
      j += 3;
  }
  return barray;
};
/**
 * Fonction renvoyant le PGCD de a et de b.
 * Avant appel a et b doivent être entiers et non tous les deux nuls, positifs ou nuls
 * @param {Integer} a : Entier positif
 * @param {Integer} b : Entier positif
 * @returns {Integer}
 */
kernel.pgcd = function(a, b) {
  while (b !== 0) {
    var r = a - b*Math.floor(a/b);
    a = b;
    b = r;
  }
  return a;
};
/**
 * Fonction renvoyant le PPCM de a et de b
 * Avant appel a et b doivent être entiers et non tous les deux nuls, positifs ou nuls
 * @param {type} a
 * @param {type} b
 * @returns {Number}
 */
kernel.ppcm = function(a, b) {
  if ((a === 0) || (b === 0)) return 0;
  var q = a/pgcd(a,b);
  return Math.floor(q*b + 0.5);
};
/**
 * Fonction renvoyant le coefficient du binôme Cnp
 * Avant appel n et p doivent être entiers, n > 0,
 * et p compris entre 0 et n
 * @param {Integer} n
 * @param {Integer} p
 * @returns {Integer}
 */
kernel.ncr = function(n, p) {
  if (p > n/2) p = n - p;
  if (p === 0) return 1;
  var d = n/p;
  var p1 = p;
  for (var k = 1; k < p1; k++) {
    p--;
    n--;
    var d1 = n/p;
    d = d*d1;
  }
  return Math.floor(d+0.5);
};
/**
 * Fonction renvoyant le nombre de permutations à p éléments d'un ensemble à n éléments
 * Avant appel n et p doivent être entiers, n > 0.
 * @param {Integer} n
 * @param {Integer} p
 * @returns {Integer}
 */
kernel.npr = function(n,  p) {
  if (p === 0) return 1;
  var d = n;
  for (var k = 1; k < p; k++) {
    n--;
    d = d*n;
  }
  return d;
};
/**
 * Fonction renvoyant true si un angle de mesure r est considéré comme
 * presque nul (valeur absolue inféieure à 10^-7)
 * @param {Float} r
 * @returns {Boolean}
 */
kernel.zeroAngle = function(r) {
    return (Math.abs(r)<1e-7);
};
/**
 * Renvoie la mesure principale en radians d'un angle de mesure angrad.
 * @param {Float} angrad
 * @returns {Float}
 */
kernel.mesurePrincipale = function(angrad) {
  if (kernel.zeroAngle(Math.abs(angrad) - Math.PI)) return Math.PI;
  return angrad - 2*Math.PI*Math.floor((angrad + Math.PI)/(2*Math.PI));
};
/**
 * Fonction renvoyant true si x et y sont des nombres compris entre le plus
 * petit et le plus grand  entiers représentés sur 4 actets.
 * @param {Float} x
 * @param {Float} y
 * @returns {Boolean}
 */
kernel.testToile = function(x, y) {
  return ((x<=kernel.SHORT_MAX_VALUE) && (y<=kernel.SHORT_MAX_VALUE)
    && (x>=kernel.SHORT_MIN_VALUE) && (y>=kernel.SHORT_MIN_VALUE));
};
/**
 * Renvoie true si les deu vecteurs e et v sont considérés comme colinéiares
 * (à epsilon près).
 * @param {Vect} u
 * @param {Vect} v
 * @returns {Boolean}
 */
kernel.colineaires = function(u, v)
{
  var n1 = u.norme();
  var n2 = v.norme();
  if (kernel.zero(n1) || kernel.zero(n2)) return true;
  else return (kernel.zero((u.x*v.y-u.y*v.x)/n1/n2));
};
/**
 * Renvoie true si les deu vecteurs e et v sont considérés comme colinéiares
 * et de même sens (à epsilon près).
 * @param {Vect} u
 * @param {Vect} v
 * @returns {Boolean}
 */
kernel.colineairesMemeSens = function(u, v) {
  return kernel.colineaires(u, v) && (u.x*v.x + u.y*v.y >= 0);
};
/**
 * Renvoie la distance entre deux points de coordonnées (x1,y1) et (x2,y2).
 * @param {Float} x1
 * @param {Float} y1
 * @param {Float} x2
 * @param {Float} y2
 * @returns {Float}
 */
kernel.distancePointPoint = function(x1,y1,x2,y2) {
  return Math.sqrt((x2-x1)*(x2-x1) + (y2-y1)*(y2-y1));
};
/**
 * Renvoie le carré de la distance entre deux points de coordonnées (x1,y1) et (x2,y2).
 * @param {Float} x1
 * @param {Float} y1
 * @param {Float} x2
 * @param {Float} y2
 * @returns {Float}
 */
kernel.distancePointPointCarre = function(x1,y1,x2,y2) {
  return (x2-x1)*(x2-x1) + (y2-y1)*(y2-y1);
};

/**
 * Calcule l'intersection de deux droites et renvoie un entier du type mtg32.PositionDroites
 * @param {Float} p1_x : Abscisse d'un point de la première droite
 * @param {Float} p1_y : Ordonnée d'un point de la première droite
 * @param {Vect} u1 : Vecteur directeur de la première droite.
 * @param {Float} p2_x : Abscisse d'un point de la deuxième droite
 * @param {Float} p2_y : Ordonnée d'un point de la deuxième droite
 * @param {Vect} u2 : Vecteur directeur de la deuxième droite.
 * @param {Point} pointInt : Contient au retour les coordonnées du point d'intersection.
 * @returns {PositionDroites}
 */
kernel.intersection = function(p1_x,p1_y,u1,p2_x,p2_y,u2,pointInt) {
  var d,k1,k2,position;

  d = u1.x*u2.y-u2.x*u1.y;
  // Modifié pour la version 1.9 : on teste la presque nullité du sinus et
  // non du déterminant
  if (kernel.zero(d/u1.norme()/u2.norme())) {
    var w = new Vect(p1_x,p1_y,p2_x,p2_y);
    // Il faut appeler colineaires() car w peut être nul
    if (kernel.colineaires(u1,w)) position = PositionDroites.Confondues;
    else position = PositionDroites.Paralleles;
  }
  else {
    position = PositionDroites.Secantes;
    k1 = u1.y*p1_x-u1.x*p1_y;
    k2 = u2.y*p2_x-u2.x*p2_y;
    pointInt.x = (u1.x*k2-u2.x*k1)/d;
    pointInt.y = (u1.y*k2-u2.y*k1)/d;
  }
  return position;
};
/**
 * Calcule l'intersection d'une droite et un cercle et renvoie un entier du type PositionDroiteCercle
 * donnant la nature de cette intersection.
 * @param {Float} px : Abscisse d'un point de la droite.
 * @param {Float} py : Ordonnées d'un point de la droite.
 * @param {mtg32.CVect} u : Un vecteur directeur de la droite.
 * @param {Float} cx : Abscisse du cntre du cercle.
 * @param {Float} cy : Ordonnée du cntre du cercle.
 * @param {Float} R : Le rayon d cercle.
 * @param {Point} point1 : Contient au retour les coordonnées du premier point d'intersection
 * (si il y en a).
 * @param {Point} point2 : Contient au retour les coordonnées du second point d'intersection
 * (si il y en a).
 * @returns {kernel.PositionDroiteCercle}
 */
kernel.intersectionDroiteCercle = function(px,py,u,cx,cy,R,point1,point2)
{
  var a,b,k1,k2,k3,k4,n2,distcentredroite,dis,t1,t2;// paramètre
  a = u.x;
  b = u.y;
  k1 = px-cx;
  k2 = py-cy;
  k3 = a*k1+b*k2;
  k4 = a*k2-b*k1;
  n2 = a*a+b*b;
  distcentredroite = Math.abs(a*k2-b*k1)/Math.sqrt(n2);
  if (kernel.zero(distcentredroite-R)) {
     t1 = -k3/n2;
     point1.x = px+a*t1;
     point1.y = py+b*t1;
     point2.x = point1.x;
     point2.y = point1.y;
     return PositionDroiteCercle.Tangents;
   }
   if (distcentredroite>R) {
     return PositionDroiteCercle.Vide;
   }
   else {
     dis = n2*R*R-k4*k4;
     t1 = (Math.sqrt(dis)-k3)/n2;// formules du second degré
     t2 = (-Math.sqrt(dis)-k3)/n2;
     point1.x = px+a*t1;
     point1.y = py+b*t1;
     point2.x = px+a*t2;
     point2.y = py+b*t2;
     return PositionDroiteCercle.Secants;
   }
};
// Idem pour l'intersection d'une droite et d'un cercle
/**
 * Calcule l'intersection de deux cercles et renvoie un entier du type PositionCercleCercle
 * donnant la nature de cette intersection.
 * @param {Float} c1x : Abscisse du centre du premier cercle.
 * @param {Float} c1y : Ordonnée du centre du premier cercle.
 * @param {Float} r1 : Rayon du premier cercle.
 * @param {Float} c2x : Abscisse du centre du second cercle.
 * @param {Float} c2y : Ordonnée du centre du second cercle.
 * @param {Float} r2 : Rayon du second cercle.
 * @param {type} point1
 * @param {type} point2
 * @returns {PositionCercleCercle}
 */
kernel.intersectionCercleCercle= function(c1x,c1y,r1,c2x,c2y,r2,point1,point2)
{
  var d,xi,yi,xh,yh,k;
  var u = new Vect();
  var v = new Vect();
  // Modifié version 2.3.5
  // if ((c1x == c2x) && (c1y == c2y))
  if (kernel.zero(c1x - c2x) && kernel.zero(c1y - c2y)) {
    if (kernel.zero(r1 - r2))  return PositionCercleCercle.Confondus;
    else return PositionCercleCercle.Vide;
  }
  else   {
    xi = (c1x + c2x)/2;
    yi = (c1y + c2y)/2; // coordonnées du milieu de M1M2;
    var u0 = new Vect(c1x, c1y, c2x, c2y);
    d = kernel.distancePointPoint(c1x,c1y,c2x,c2y);
    u0.vecteurColineaire(1,u); // u colinéaire à M1M2 et même sens
    k = (r1*r1-r2*r2)/2/d;
    xh = xi + k*u.x;
    yh = yi + k*u.y;
    u.getOrthogonal(v);
    var positionDroites = kernel.intersectionDroiteCercle(xh,yh,v,c1x,c1y,r1,point1,point2);
    switch (positionDroites)
    {
      case PositionDroiteCercle.Tangents:
        return PositionCercleCercle.Tangents;
      case PositionDroiteCercle.Secants:
        return PositionCercleCercle.Secants;
      case PositionDroiteCercle.Vide:
        return PositionCercleCercle.Vide;
      default : return PositionCercleCercle.Vide; // Pour satisfaire le compilateur
    }
  }
};
/**
 * Renvoie dans res.x et res.y les coordonnées de l'intersection de deux droites sécantes
 * On sait qu'elles sont sécantes avant appel.
 * @param {Float} p1_x : Abscisse d'un point de la première droite
 * @param {Float} p1_y : Ordonnée d'un point de la première droite
 * @param {Vect} u1 : Vecteur directeur de la première droite.
 * @param {Float} p2_x : Abscisse d'un point de la deuxième droite
 * @param {Float} p2_y : Ordonnée d'un point de la deuxième droite
 * @param {Vect} u2 : Vecteur directeur de la deuxième droite.
 * @param {Object} res
 * @returns {undefined}
 */
kernel.intersectionDroitesSecantes = function(p1_x,p1_y,u1,p2_x,p2_y,u2, res) {
  var d,k1,k2;
  d = u1.x*u2.y-u2.x*u1.y;
  k1 = u1.y*p1_x-u1.x*p1_y;
  k2 = u2.y*p2_x-u2.x*p2_y;
  res.x = (u1.x*k2-u2.x*k1)/d;
  res.y = (u1.y*k2-u2.y*k1)/d;
};
/**
 * Renvoie dans res.x et res.y les coordonnées du projeté orthogonal du point
 * de coordonnées (x1,y1) sur la droite passant par le point de coordonnées
 * (p1_x,p1_y) et de vecteur directeur u.
 * @param {Float} x1
 * @param {Float} y1
 * @param {Float} p1_x
 * @param {Float} p1_y
 * @param {Vect} u
 * @param {Object} res
 * @returns {undefined}
 */
kernel.projetteOrtho = function(x1,y1,p1_x,p1_y,u,res)
{
  var v = new Vect();
  u.getOrthogonal(v);
  kernel.intersectionDroitesSecantes(x1,y1,v,p1_x,p1_y,u,res);
};
/**
 * Renvoie true si les poins de coordonnées (xa,ya), (xb,yb) et (xc,yc)
 * sont considérés comme pratiquement alignés.
 * @param {Float} xa
 * @param {Float} ya
 * @param {Float} xb
 * @param {Float} yb
 * @param {Float} xc
 * @param {Float} yc
 * @returns {Boolean}
 */
kernel.aligne = function(xa,ya,xb,yb,xc,yc) {
  var k,nu,nv;
  var u = new Vect();
  var v = new Vect();

  u.x = xb-xa;
  u.y = yb-ya;
  v.x = xc-xa;
  v.y = yc-ya;
  nu = u.norme();
  nv = v.norme();
  if (kernel.zero(nu) || kernel.zero(nv))  return true;
  else {
    k = (u.x*v.y-v.x*u.y)/nu/nv;
    return kernel.zero(k);
  }
};
/**
 * Renvoie true si le point de coordonnées (x,y) est considéré comme appartenant
 * au segment dont les extrémités ont pour coordonnées (p1x,p1y) et (p2x,p2y).
 * @param {Float} x
 * @param {Float} y
 * @param {Float} p1x
 * @param {Float} p1y
 * @param {Float} p2x
 * @param {Float} p2y
 * @returns {Boolean}
 */
kernel.appartientSegment = function(x,y,p1x,p1y,p2x,p2y) {
  var k,absx,absy;
  var difx = p2x-p1x;
  absx = Math.abs(difx);
  var dify = p2y-p1y;
  absy = Math.abs(dify);
  if (kernel.zero(difx) && kernel.zero(dify))
    return (kernel.zero(x - p1x) && kernel.zero(y - p1y));
  else {
    if (!(kernel.aligne(p1x,p1y,p2x,p2y,x,y))) return false;
    else {
      if (absy > absx) k = (y-p1y)/dify;
      else k = (x-p1x)/difx;
      // Modification apportée pour la version 1.9.5 pour compter avec les erreurs d'arrondi
      return (((k>=0) && (k<=1)) || kernel.zero(k) || kernel.zero(1-k))
    }
  }
};
/**
 * Fonction calculant les coefficients barycentriques d'un point sur un segment
 * @param {Float} x : abscisse du point qui est sur le segment
 * @param {Float} y : ordonnée du point qui est sur le segment
 * @param {Float} x1 : Abscisse du point1 du segment
 * @param {Float} y1 : Ordonnée du point1 du segment
 * @param {Float} x2 : Abscisse du point2 du segment
 * @param {Float} y2 : Ordonnée du point2 du segment
 * @param {mtg32.Pointeur} a : Au retour, getValue() renvoie le premier coefficient barycentrique.
 * @param {mtg32.Pointeur} b : Au retour, getValue() renvoie le second coefficient barycentrique.
 * @returns {undefined}
 */
kernel.coefficientsPointSurSegment = function(x, y, x1, y1, x2, y2, a, b) {
  var u = new Vect(x, y, x1, y1);
  var v = new  Vect(x, y, x2, y2);
  var nu = u.norme();
  var nv = v.norme();
  var d = nu + nv;
  a.setValue(nv/d);
  b.setValue(nu/d);
};
/**
 * Fonction renvoyant true seulement si le point de coordonnées (x; y)intérieur
 * au triangle dont les sommets ont pour coordonnées (x1; y1), (x2, y2) et (x3, y3).
 * Il peut être sur le côté M1M2 ou sur le côté M2M3.
 * Sert pour déterminer la position d'un point lié à l'intérieur d'un polygone.
 * @param {Float} x
 * @param {Float} y
 * @param {Float} x1
 * @param {Float} y1
 * @param {Float} x2
 * @param {Float} y2
 * @param {Float} x3
 * @param {Float} y3
 * @returns {Boolean}
 */
kernel.estInterieurATriangle = function(x, y, x1, y1, x2, y2, x3, y3) {
  if (kernel.appartientSegment(x, y, x1, y1, x2, y2) || kernel.appartientSegment(x, y, x2, y2, x3, y3)) return true;
  var u = new Vect(x, y, x1, y1);
  var v = new Vect(x, y, x2, y2);
  var w = new Vect(x, y, x3, y3);
  var ang = u.mesureAngleVecteurs(v) + v.mesureAngleVecteurs(w) + w.mesureAngleVecteurs(u);
  var q = Math.abs(Math.round(ang/(2*Math.PI)));
  return q === 1;
};
/**
 * Pour un point G intérieur à un triangle dont les sommets sont (x1,y1) (x2, y2) et (x3, y3), renvoie dans alpha
 * beta et gamma les coordonnées barycentriques normalisées du point de coordonnées (x,y) (la somme des coeff est 1)
 * G peut être éventuelleùent sur M1M2 ou sur M1M3
 * @param {float} x
 * @param {float} y
 * @param {float} x1
 * @param {float} y1
 * @param {float} x2
 * @param {float} y2
 * @param {float} x3
 * @param {float} y3
 * @param {types.Pointeur} alpha
 * @param {types.Pointeur} beta
 * @param {types.Pointeur} gamma
 * @returns {undefined}
 */
kernel.coefficientsPointInterieur = function(x, y, x1, y1, x2, y2, x3, y3, alpha, beta, gamma ) {
  if (kernel.appartientSegment(x, y, x1, y1, x2, y2)) {
    kernel.coefficientsPointSurSegment(x, y, x1, y1, x2, y2, alpha, beta);
    gamma.setValue(0);
    return;
  }
  if (kernel.appartientSegment(x, y, x1, y1, x3, y3)) {
    kernel.coefficientsPointSurSegment(x, y, x1, y1, x3, y3, alpha, gamma);
    beta.setValue(0);
    return;

  }
  var u = new Vect(x, y, x1, y1);
  var v = new Vect(x2, y2, x3, y3);
  //On calcule l'intersection de (AM) avec (BC)
  var d = u.x*v.y-v.x*u.y; // d ne doit pas être nul car u et v ne sont pas colinéaires
  // puisque le point est strictement intérieur au triangle
  var k1 = u.y*x1-u.x*y1;
  var k2 = v.y*x2-v.x*y2;
  var xs = (u.x*k2-v.x*k1)/d;
  var ys = (u.y*k2-v.y*k1)/d;
  // xs et ys sont les coordonnées du point d'intersection H qui est sur le segment [BC]
  var ga = u.norme();
  var v1 = new Vect(xs, ys, x2, y2);
  var hb = v1.norme();
  var v2 = new Vect(xs, ys, x3, y3);
  var hc = v2.norme();
  var v3 = new Vect(xs, ys, x, y);
  var gh = v3.norme();
  var den1 = ga + gh;
  var den2 = den1*(hb + hc);
  alpha.setValue(gh/den1);
  beta.setValue(ga*hc/den2);
  gamma.setValue(ga*hb/den2);
};
/**
 * Fonction renvoyant dans point.x l'indice de la valeur maximale contenue dans le tableau
 * de nombres tab et dans y l'indice de la valeur maximale.
 * @param {int} c Le nombre d'éléments du tableau.
 * @param {Array} tab : Un tableau de nombres
 * @param {Object} point
 * @returns {undefined}
 */
kernel.indiceMiniMaxi = function(c,tab,point)
{
  var imin,imax,min,max;

  min = tab[0];
  max = min;
  imin = 0;
  imax = 0;
  for (var i = 1; i <= c; i++) {
    if (tab[i]<min) {
      imin = i;
      min = tab[i];
    }
    if (tab[i]>max) {
      imax = i;
      max = tab[i];
    }
  }
  point.x = imin;
  point.y = imax;
};
/**
 * Renvoie true si la différence entre angle1 et angle2 est en valeur absolue
 * proche de pi/2 ou 3pi/2
 * @param {float} angle1
 * @param {float} angle2
 * @returns {boolean}
 */
kernel.testAngleDroit = function(angle1,angle2){
  var dif = Math.abs(angle2 - angle1);
  return kernel.zeroAngle(dif - Math.PI/2) || kernel.zeroAngle(dif - 3*Math.PI/2);
};
/**
 * Renvoie les coordonnées du pointeur souris de l'événement event
 * @param {event} event
 * @returns {Array} : Contient les coordonnées renvoyées.
 */
kernel.getMousePosition = function(event) {
  var e = event || window.event;
  var scroll = [(document.documentElement && document.documentElement.scrollLeft) || window.pageXOffset || self.pageXOffset || document.body.scrollLeft,(document.documentElement && document.documentElement.scrollTop) || window.pageYOffset || self.pageYOffset || document.body.scrollTop];
  return [e.clientX + scroll[0] - document.body.clientLeft,e.clientY + scroll[1] - document.body.clientTop];
};
/**
 * Renvoie les coordonnées du pointeur d'un périphériqu mobile de l'événement event
 * @param {type} event
 * @returns {Array} : Contient les coordonnées renvoyées.
 */
kernel.getTouchPosition = function(event) {
  var e = event || window.event;
  var scroll = [(document.documentElement && document.documentElement.scrollLeft) || window.pageXOffset || self.pageXOffset || document.body.scrollLeft,(document.documentElement && document.documentElement.scrollTop) || window.pageYOffset || self.pageYOffset || document.body.scrollTop];
  return [e.targetTouches[0].clientX + scroll[0] - document.body.clientLeft,e.targetTouches[0].clientY + scroll[1] - document.body.clientTop];
  // return [e.touches[0].pageX,e.touches[0].pageY];
};
/**
 * Renvoie l'offset d'un élément du DOM par rapport à la fenêtre parente de niveau
 * le plus élevé.
 * @param {htmlElement} e
 * @returns {Array} : Tableau contenant les coordonnées retournées.
 */
/**
kernel.getOffset = function(e) {
  var offleft = e.offsetLeft;
  var offtop = e.offsetTop;
  var parent = e.offsetParent;
  while (parent != null) { // Ne pas être mettre un test !==
    offleft += parent.offsetLeft;
    offtop += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return [offleft,offtop];
};
 */
/**
 * Renvoie l'offset d'un élément du DOM par rapport à la fenêtre parente de niveau
 * le plus élevé.
 * @param {type} e : un div
 * @returns {Object} x et y contiennent l'offset du div
 */

kernel.getPosition2 = function(e){
  if (e.getBoundingClientRect) return kernel.getOffsetRect(e);
  var left = 0;
  var top = 0;
  while (e.offsetParent != undefined && e.offsetParent != null) {
    left += e.offsetLeft + (e.clientLeft != null ? e.clientLeft : 0) - e.offsetParent.scrollLeft;
    top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0) - e.offsetParent.scrollTop;
    e = e.offsetParent;
  }
  return [left,top];
};

kernel.getOffsetRect = function(elem) {
   var box = elem.getBoundingClientRect();
   var body = document.body;
   var docElem = document.documentElement;

   var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
   var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

   var clientTop = docElem.clientTop || body.clientTop || 0;
   var clientLeft = docElem.clientLeft || body.clientLeft || 0;

   var top  = box.top +  scrollTop - clientTop;
   var left = box.left + scrollLeft - clientLeft;

   return [Math.round(left), Math.round(top)];

};
/* Abandonné version 4.9.9.3
mtg32.getPosition2FirstNonStatic = function(e){
  var left = 0;
  var top = 0;
  // var pos = e.style.position;
  while (((e.style.position == "" ) || (e.style.position == "static")) && e.offsetParent != undefined && e.offsetParent != null)
  {
    left += e.offsetLeft + (e.clientLeft != null ? e.clientLeft : 0);
    top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0);
    e = e.offsetParent;
  }
  return {
    x:left,
    y:top
  };
}
*/
/**
 * Rend les élements de el non sélectionnables à la souris.
 * @param {htmlElement} el
 * @returns {undefined}
 */
/** Abandonné et remplacé par une feuille de styles css
kernel.disableSelection = function(el) {
  var s = el.style;
  s.userSelect = "none";
  s.webkitUserSelect = "none";
  s.MozUserSelect = "none";
  el.setAttribute("unselectable", "on");
};
 */
/* Abandonné version 4.9.2
mtg32.getDiv4Start =  function(id) {
  var div = document.createElement("div");
  div.setAttribute("id", id);
  div.setAttribute("style", "border:1px;font-size: 12px;visibility: hidden;");
  div.innerHTML = "$$ \\textcolor{blue}{M} \\color[RGB]{0,0,0} \\alpha \\beta \\gamma \\delta \\varepsilon \\zeta \\eta \\theta \\kappa \\lambda \\mu \\nu \\xi \\pi \\rho \\sigma \\tau \\varphi \\chi \\psi \\omega \\Gamma \\Delta \\Xi \\Pi \\Sigma \\Phi \\Psi \\Omega \\le \\ge \\forall \\exists \\emptyset \\nabla \\notin \\in \\ni \\prod \\sum \\infty \\wedge \\vee \\cap \\cup \\int \\sim \\cong \\approx \\sim \\simeq \\ne \\equiv \\subset \\not\\subset \\supset \\ell \\perp \\oplus \\otimes \\uparrow \\leftarrow \\rightarrow \\downarrow \\leftrightarrow \\updownarrow \\Leftrightarrow \\Rightarrow \\Leftarrow \\nLeftrightarrow \\mapsto \\nRightarrow \\nLeftarrow \\hookleftarrow \\hookrightarrow \\circlearrowleft \\circlearrowright \\begin{array}{l}{x}\\\\ {1}\\\\ {\\left( \\frac{u}{v } \\right)=} \\\\ {f'(x)=\\frac{2\\left( {x-3 } \\right) - \\left( {2x } \\right)}{\\left( {x-3 } \\right)^2 }=\\frac{2x-6-2x }{\\left( { x-3 } \\right)^2}} \\\\ {\\text{donc }f'(x) = \\frac{-6 }{\\left( {x-3 } \\right)^2 } } \\end{array} \\left[{a}\\right] u^2 \\text{abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ() .éèêà} \\times - + a^2 \\int_{a}^{b} f'(t)dt \\vec{u} \\overrightarrow {AB} \\overline {AB} \\underline {AB} \\widehat{BAC} \\sin \\cos \\tan \\ln \\lim_{x \\to { }} \\left\\| {a} \\right\\| \\sum_{a}^{b} \\prod{a}^{b} \\lim_{x \\to {a}} \\begin{matrix}{a} & {b}\\\\{c} & {d}\\end{matrix} \\sqrt{\\frac{x^2}{x+1}} \\sqrt [3] {a} \\acute{e} \\grave{e} \\grave{a} \\grave{u} \\hat{e} \\hat{o} \\hat{a}  $$"
  return div;
}
*/

kernel.divComp = function(z1, z2, zRes) {
  var a, b, c, d, r, den;
  a = z1.x;
  b = z1.y;
  c = z2.x;
  d = z2.y;
  if ( Math.abs (d) <= Math.abs (c) ) {
    r = d/c;
    den = c + d * r;
    zRes.x = (a + b * r) / den;
    zRes.y = (b - a * r) / den;
  }
  else {
    r = c/d;
    den = c * r + d;
    zRes.x = (a * r + b) / den;
    zRes.y = (b * r - a) / den;
   }
};

/**
 * Fonction renvoyant true si le point de coordonnées (x,y) est sur le cercle (ou descendant de cercle)
 * @param cercle
 * @param x
 * @param y
 * @return
 */
kernel.appartientCercle = function(cercle, x, y) {
  return kernel.zero(kernel.distancePointPoint(x, y, cercle.centre_x, cercle.centre_y) - cercle.rayon);
};

kernel.descriptionNature = [
  "PointLibre", "PointCons", "PointLie",
  "Barycentre", "PointRep", "PointLibreEnt",
  "PointParAff", "PointLiePoint", "Macro",
  "Dte", "Vect", "Seg", "Ddte",
  "Cerc", "MarqueAng", "Arc",
  "Polygone", "Surf", "LieuPt",
  "LieuPtDis", "LigneBrisee",
  "LieuObj", "Image", "GrapheSuiteR",
  "GrapheSuiteComp", "Comment", "AffVal",
  "MarqueSeg", "ObjetDup", "DemiPlan",
  "PtIntPoly", "Latex", "PtIntCerc",
  "EditeurFor", "PtClone", "DteClone", "DdteClone",
  "SegClone", "CercClone"
];


module.exports = kernel



// WEBPACK FOOTER //
// ./src/kernel/kernel.js